import React, { useContext, useState } from "react";
import {
  Avatar,
  Box,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Paper,
  Typography,
  Divider,
  useTheme
} from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../auth/AuthContext";

const TOPBAR_HEIGHT = 90;

export default function DashboardTopbar({ title = "Dashboard" }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const onOpenMenu = (e) => setAnchorEl(e.currentTarget);
  const onCloseMenu = () => setAnchorEl(null);

  const onLogout = () => {
    onCloseMenu();
    logout();
    navigate("/auth");
  };

  return (
    <Box
      sx={{
        height: TOPBAR_HEIGHT,
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        px: 3,
        display: "flex",
        alignItems: "center",
        gap: 3,
        position: "sticky",
        top: 0,
        zIndex: 20
      }}
    >


      {/* Title */}
      <Typography
        sx={{
          fontSize: 20,
          fontWeight: 800,
          color: theme.palette.text.primary
        }}
      >
        {title}
      </Typography>

      <Box sx={{ flex: 1 }} />

      {/* Search Box */}
      <Paper
        elevation={0}
        sx={{
          width: 330,
          borderRadius: 3,
          px: 2,
          py: 1,
          display: "flex",
          alignItems: "center",
          border: `1px solid ${theme.palette.divider}`
        }}
      >
        <SearchRoundedIcon sx={{ fontSize: 20, opacity: 0.5, mr: 1 }} />
        <InputBase
          placeholder="Search…"
          sx={{
            flex: 1,
            fontSize: 14
          }}
        />
      </Paper>

      {/* Avatar Menu */}
      <IconButton onClick={onOpenMenu} sx={{ ml: 2 }}>
        <Avatar
          sx={{
            width: 38,
            height: 38,
            bgcolor: theme.palette.primary.main,
            color: "#fff",
            fontWeight: 700
          }}
        >
          {(user?.fullName || "U")[0]?.toUpperCase()}
        </Avatar>
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={onCloseMenu}
        PaperProps={{
          sx: {
            mt: 1,
            borderRadius: 2,
            border: `1px solid ${theme.palette.divider}`,
            minWidth: 220
          }
        }}
      >
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography sx={{ fontWeight: 800, fontSize: 14 }}>
            {user?.fullName}
          </Typography>
          <Typography sx={{ fontSize: 12, opacity: 0.7 }}>
            {user?.email}
          </Typography>
        </Box>

        <Divider />

        <MenuItem
          onClick={() => {
            onCloseMenu();
            navigate("/settings");
          }}
          sx={{ fontWeight: 600, fontSize: 14, py: 1.2 }}
        >
          <SettingsRoundedIcon sx={{ fontSize: 18, mr: 1 }} /> Settings
        </MenuItem>

        <MenuItem
          onClick={onLogout}
          sx={{
            color: "red",
            fontWeight: 700,
            fontSize: 14,
            py: 1.2
          }}
        >
          <LogoutRoundedIcon sx={{ fontSize: 18, mr: 1 }} /> Logout
        </MenuItem>
      </Menu>
    </Box>
  );
}

export { TOPBAR_HEIGHT };
